import React from 'react';
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/modern/components/ui/dropdown-menu';
import {
  canArchive,
  canDelete,
  canShare,
  canCopyToBoard,
} from '../contextMenuUtils';
import { Client } from '@/bryntum-lib/models/Client';
import { useSwivuBryntumContext } from '@/react/hooks/useSwivuBryntumContext';

interface ClientContextMenuProps {
  record: Client;
  onClose?: () => void;
  onItemClick?: (item: { name: string; }) => void;
}

const ClientContextMenu: React.FC<ClientContextMenuProps> = ({ record, onItemClick }) => {
  const context = useSwivuBryntumContext();
  const { user, selectedBoard, boardManager } = context;

  const isDemoUser = user?.isDemoUser ?? false;

  // Permission checks
  const showArchive = user ? canArchive(user, record) : false;
  const showDelete = user ? canDelete(user, record) : false;
  const showShare = user ? canShare(user, isDemoUser, record) : false;
  const showCopyTo = user ? canCopyToBoard(user, isDemoUser, selectedBoard, boardManager?.boardNameStore) : false;

  const handleArchive = async () => {
    onItemClick?.({ name: 'archive' });
  };

  const handleDelete = async () => {
    onItemClick?.({ name: 'delete' });
  };

  const handleShare = () => {
    onItemClick?.({ name: 'share' });
  };

  const handleCopyTo = () => {
    onItemClick?.({ name: 'copyTo' });
  };

  return (
    <>
      {/* Share */}
      <DropdownMenuItem onClick={handleShare} disabled={!showShare}>
        <i className="fa-light fa-share mr-2" />
        <span>Share</span>
      </DropdownMenuItem>

      {/* Copy to */}
      <DropdownMenuItem onSelect={(e) => e.preventDefault()} onClick={handleCopyTo} disabled={!showCopyTo}>
        <i className="fa-light fa-copy mr-2" />
        <span>Copy to</span>
      </DropdownMenuItem>

      {/* Separator before Archive/Delete */}
      <DropdownMenuSeparator />

      {/* Archive/Unarchive */}
      <DropdownMenuItem onClick={handleArchive} disabled={!showArchive}>
        <i className="fa-light fa-folder-open mr-2" />
        <span>{record?.archived ? 'Unarchive' : 'Archive'}</span>
      </DropdownMenuItem>

      {/* Delete */}
      <DropdownMenuItem onClick={handleDelete} className="text-destructive" disabled={!showDelete}>
        <i className="fa-light fa-trash mr-2" />
        <span>Delete</span>
      </DropdownMenuItem>
    </>
  );
};

export default ClientContextMenu;